import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Action } from 'redux';
import { LoadRelease, ValidateReleaseArtists } from '../action-creators';
import { LOAD_RELEASE } from '../actions';

export const validateArtistsAfterLoadEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, LoadRelease>(LOAD_RELEASE),
    map(
      (action) => new ValidateReleaseArtists(action.artistId, action.releaseId)
    )
  );
